import {
  Component, Input, Output, EventEmitter, ChangeDetectorRef, HostListener
} from '@angular/core';
import { formService } from '../../Service/formService';
import { Token } from '../../Models/Token';
import { ePayService } from "../../Service/ePayService";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'card-connect',
  templateUrl: 'cardconnect.component.html',
  styleUrls: ['cardconnect.component.css'],
  exportAs: 'ngModel'
})
export class CardConectComponent {
  private token: Token = new Token();
  public validCard: boolean = false;
  public valid: boolean = false;
  public invalid: boolean = true;
  public isCardValid: boolean = false;
  private iframeUrl: any = null;

  //Listed card connect for the cc token
  @HostListener('window:message', ['$event'])
  onMessage(e: any) {
    if (this.EPayService) {
      if (e) {
        if (this.EPayService.Processor().indexOf(e.origin) < 0) {
          return false;
        }
        else {
          if (e.data) {
            try {
              this.carddata = <Token>JSON.parse(e.data);              
              console.log('carddata', this.carddata);
            }
            catch
            {
            }
          }
        }
      }
    }
  }
  
  //get/set the card data
  @Input() get carddata(): Token {
    return this.token;
  }
  set carddata(value: Token) {
    this.token = value;
  }

  @Output() carddataChange: EventEmitter<Token> = new EventEmitter();

  //Get the iframe
  get iframeURL() {
    return this.iframeUrl;
  }
  
  //Validate the card token
  ngAfterViewChecked() {
    this.valid = false;
    if (this.carddata) {
      if (this.carddata.validationError !== undefined) {
        this.valid = false;
      }
      else {
        if (this.carddata.message !== undefined && this.carddata.expiry !== undefined) {
          if (this.carddata.message != "undefined") {
            if (this.carddata.message && this.carddata.expiry) {
              this.valid = true;
            }
          }
        }
      }
    }
    this.carddata.valid = this.valid;
    this.invalid = !this.valid;

    this.carddataChange.emit(this.token);
    this.cdRef.detectChanges();
  }

  constructor(private cdRef: ChangeDetectorRef, private sanitizer: DomSanitizer,
    private FormService: formService) {
  }

  //Get the iframe url
  ngOnInit() {
    if (this.EPayService) {
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.EPayService.iFrame());
    }
  }

  get EPayService(): ePayService {
    return this.FormService.EPayService;
  }
  
}
